import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { InputDataUrl } from './InputDataUrl';
import { OutputVersionArraySchema } from '../schema/InputDataSchema';

export interface OutputVersionParams {
  descriptionId: string;
  outputDataObjectId: number;
  subject: string;
  valueDate: string;
}

const getOutputVersions = (params?: OutputVersionParams) =>
  apiClient
    .get(expand(InputDataUrl.OUTPUT_VERSIONS, params))
    .then((response) => OutputVersionArraySchema.parse(response.data));

export const useOutputVersionQuery = createApiQueryHook(
  ['useOutputVersions'],
  getOutputVersions
);
